<script setup lang="ts">
const { t } = useI18n();
const { openModal } = useCookieConsent();
</script>

<template>
  <div
    role="region"
    :aria-label="t('cookies.map.placeholder.title')"
    class="size-full min-h-60 flex flex-col items-center justify-center gap-4 px-6 py-8 text-center bg-blue-100 text-blue-800"
  >
    <div class="flex flex-col gap-1">
      <p class="text-lg font-semibold">{{ t("cookies.map.placeholder.title") }}</p>
      <p class="">{{ t("cookies.map.placeholder.description") }}</p>
    </div>
    <UButton color="primary" size="md" @click="openModal">
      {{ t("cookies.map.enable") }}
    </UButton>
  </div>
</template>
